<script setup lang="ts">
defineProps<{
  title?: string
  subtitle?: string
  loading?: boolean
  empty?: boolean
  emptyText?: string
}>()
</script>

<template>
  <UCard :ui="{ root: 'overflow-visible', body: 'p-4! sm:p-4!' }">
    <template v-if="title || $slots.actions || $slots.latest" #header>
      <div class="flex items-start justify-between gap-3">
        <div class="min-w-0">
          <h3 class="text-highlighted truncate font-semibold">
            {{ title }}
          </h3>
          <p v-if="subtitle" class="text-muted text-sm">
            {{ subtitle }}
          </p>
        </div>
        <div class="flex items-center gap-2">
          <UIcon v-if="loading" name="i-lucide-loader-circle" class="text-dimmed size-4 animate-spin" />
          <slot name="latest" />
          <slot name="actions" />
        </div>
      </div>
    </template>

    <div
      v-if="empty"
      class="text-muted flex h-40 flex-col items-center justify-center gap-2 text-sm"
    >
      <UIcon name="i-lucide-chart-line" class="size-6" />
      {{ emptyText ?? 'No data for the selected range.' }}
    </div>
    <slot v-else />
  </UCard>
</template>
